import { ContentApiDatasource } from '../data/datasources/content-api.datasource';
import { ContentRepositoryImpl } from '../data/repositories/content.repository.impl';
import { HarrisonApiDatasource } from '../data/datasources/harrison-api.datasource';
import { HarrisonRepositoryImpl } from '../data/repositories/harrison.repository.impl';

const api = new ContentApiDatasource();
const repository = new ContentRepositoryImpl(api);
const harrisonRepository = new HarrisonRepositoryImpl(
  new HarrisonApiDatasource(),
);

export const contentContainer = { repository, harrisonRepository };
